export const buildUrlParamsString = (params: Record<string, any>): string => {
  const url = new URL('https://example.com');
  Object.keys(params).forEach((key) => {
    url.searchParams.set(key, params[key]);
  });
  return url.search;
};

